<template>
  <div>
    <my-asidebar v-bind:active-tab="'reports'"> </my-asidebar>
    <section class="dashboard-area p-3">
      <top-bar></top-bar>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="title">Sail Booking Report</h3>
              </div>
            </div>
            <div class="row mb-3 ml-2">
<!--              <div class="col-sm-3">-->
<!--                <base-select-input-->
<!--                    v-model="selectedAgency"-->
<!--                    :optionList="agencyList"-->
<!--                    class="mr-4"-->
<!--                    :label="'Rezerve edilen Acente'">-->
<!--                </base-select-input>-->
<!--              </div>-->
              <div class="col-sm-3">
                <div class="input-box">
                  <label class="label-text">Başlangıç Tarihi</label>
                  <div class="input-box">
                    <input class="form-control" v-model="startDate" id="startDate" type="date" placeholder="">
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="input-box">
                  <label class="label-text">Bitiş Tarihi</label>
                  <div class="input-box">
                    <input class="form-control" v-model="endDate" id="endDate" type="date" placeholder="">
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <label class="label-text"> - </label>
                <div class="input-box">
                  <button @click="loadReport" class="theme-btn theme-btn-small" type="button" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                    Getir
                  </button>
                </div>
              </div>
            </div>
            <v-app>
              <v-data-table
                  :headers="headers"
                  :items="forecastData"
                  :items-per-page="100"
                  class="elevation-1"
                  :search="search"
                  :custom-filter="filter"
              >
                <template
                    v-for="header in headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
                    v-slot:[`item.${header.value}`]="{ header, value }"
                >
                  {{ header.formatter(value) }}
                </template>
<!--                <template v-slot:item.sailDate="{ item }">-->
<!--                  <tr>-->
<!--                    {{ item.sailDate | ddMMyyyy }}-->
<!--                  </tr>-->
<!--                </template>-->
              </v-data-table>
            </v-app>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ReservationStatus from "../component/common/ReservationStatus";
import BaseEditInput from "../component/base/BaseEditInput";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";
import BaseSelectInput from "../component/base/BaseSelectInput";
import {ddMMyyyy, ddMMyyyyHHmmSS, toCurrency, toCurrencyTRY, yyyy_MM_dd_tire} from "../util/filters";
// import generalFunctions from "../util/generalFunctions";

export default {
  name: "BookingAgencyCommissionReportPage",
  components: {BaseSelectInput, TopBar, MyAsidebar, BaseEditInput, ReservationStatus},
  data () {
    return {
      startDate : yyyy_MM_dd_tire(new Date().getTime()-86400000),
      endDate : yyyy_MM_dd_tire(new Date().getTime()),
      selectedAgency : null,
      forecastData: [],
      sending : false,
      email: null,
      search: '',
      headers: [
        {
          align: 'start',
          text: 'bookingNumber',
          sortable: true,
          value: 'bookingNumber',
        },
        {
          text: 'totalPrice',
          sortable: true,
          value: 'totalPrice',
          formatter: toCurrency
        },
        {
          text: 'taxPrice',
          sortable: true,
          value: 'taxPrice',
          formatter: toCurrency
        },
        {
          text: 'price',
          sortable: true,
          value: 'price',
          formatter: toCurrency
        },
        {
          text: 'passengerCount',
          sortable: true,
          value: 'passengerCount'
        },
        {
          text: 'bookingStatus',
          sortable: true,
          value: 'bookingStatus'
        },
        {
          text: 'contactEmail',
          sortable: true,
          value: 'contactEmail'
        },
        {
          text: 'contactPhone',
          sortable: true,
          value: 'contactPhone'
        },
        {
          text: 'contactName',
          sortable: true,
          value: 'contactName'
        },
        {
          text: 'createDate',
          sortable: true,
          value: 'createDate',
          formatter: ddMMyyyyHHmmSS
        },
        {
          text: 'confirmed',
          sortable: true,
          value: 'confirmed'
        },
        {
          text: 'sailDate',
          sortable: true,
          value: 'sailDate',
          formatter: ddMMyyyy
        },
        {
          text: 'seaTourNights',
          sortable: true,
          value: 'seaTourNights'
        },
        {
          text: 'seaTourName',
          sortable: true,
          value: 'seaTourName'
        },
        {
          text: 'agencyName',
          sortable: true,
          value: 'agencyName'
        },
        {
          text: 'agencyCommissionRate',
          sortable: true,
          value: 'agencyCommissionRate'
        },
        {
          text: 'exchangeRate',
          sortable: true,
          value: 'exchangeRate'
        },
        {
          text: 'saleInTL',
          sortable: true,
          value: 'saleInTL',
          formatter: toCurrencyTRY
        },
        {
          text: 'agencyCommissionInEUR',
          sortable: true,
          value: 'agencyCommissionInEUR',
          formatter: toCurrency

        },
        {
          text: 'agencyCommissionInTL',
          sortable: true,
          value: 'agencyCommissionInTL',
          formatter: toCurrencyTRY
        }
      ]
    }
  },
  computed:{
    // agencyList:{
    //   get(){
    //     return this.$store.getters.getAgencyList;
    //   }
    // },
    sailBookingReportData:{
      get(){
        let sailBookingReportData = this.$store.getters.getSailReportData;
        if(!sailBookingReportData) return null;

        sailBookingReportData.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.sailDate) - new Date(a.sailDate);
        });

        return sailBookingReportData;
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  methods:{
    loadReport(){
      this.$store.dispatch("loadBookingAgencyCommissionReportData", {
        // "agencyId" : this.selectedAgency,
        "startDate" : this.startDate,
        "endDate" : this.endDate
      }).then(response =>{
        this.forecastData = response;
      });
    },
    filter (value, search, item) {
      if(value == null || search == null){
        return false;
      }

      return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },
  },
  mounted() {
    debugger
    if(!this.panelRights["PANEL_PAGE_BOOKING_AGENCY_COMMISSION_RATE_REPORT"]) this.$router.push("/");
    this.loadReport();
  }
}
</script>

<style scoped>

</style>